<script>
import ModalWrapperChoice from "@/components/modals/ModalWrapperChoice";

export default {
  name: "SacrificeModal",
  components: {
    ModalWrapperChoice
  },
  data() {
    return {
      currentMultiplier: new Decimal(),
      nextMultiplier: new Decimal(),
    };
  },
  computed: {
    message() {
      if (Achievement(118).isUnlocked && !Pelle.isDoomed) {
        return `Жертвование Измерений даст бонус к 8ому Измерению Антиматерии, основываясь на количестве
          1ых Измерений Антиматерии, которые были у вас на момент Жертвования.`;
      }
      return `Жертвование Измерений удалит все Измерения Антиматерии с 1ого по 7ое
        (цена и множитель останутся прежними), для бонуса к 8ому Измерению Антиматерии, основываясь на общем
        количестве пожертвованных 1ых Измерений Антиматерии. Восстановление производства займёт некоторое время.`;
    },
    multiplierText() {
      return `Множитель на данный момент равен ${formatX(this.currentMultiplier, 2, 2)} и будет повышен до
        ${formatX(this.nextMultiplier, 2, 2)} после Жертвования Измерений.`;
    },
  },
  methods: {
    update() {
      this.currentMultiplier.copyFrom(Sacrifice.totalBoost);
      this.nextMultiplier.copyFrom(Sacrifice.nextBoost.times(Sacrifice.totalBoost));
    },
    handleYesClick() {
      sacrificeReset();
    }
  },
};
</script>

<template>
  <ModalWrapperChoice
    option="sacrifice"
    @confirm="handleYesClick"
  >
    <template #header>
      Жертвование Измерений
    </template>
    <div class="c-modal-message__text">
      {{ message }}
    </div>
    <br>
    <div class="c-modal-message__text">
      {{ multiplierText }}
      <br>
    </div>
  </ModalWrapperChoice>
</template>
